import { AddInError } from './addInError';

export class OfficeSingleSignOnError extends AddInError {
  readonly code: number;

  constructor(message: string, code: number, context?: Record<string, unknown>) {
    super(message, context);
    this.name = 'OfficeSingleSignOnError';
    this.code = code;
    Object.setPrototypeOf(this, OfficeSingleSignOnError.prototype);
  }
}
